import { render, staticRenderFns } from "./AcademicComplianceNotice.vue?vue&type=template&id=0cba7415&scoped=true&"
import script from "./AcademicComplianceNotice.vue?vue&type=script&lang=js&"
export * from "./AcademicComplianceNotice.vue?vue&type=script&lang=js&"
import style0 from "./AcademicComplianceNotice.vue?vue&type=style&index=0&id=0cba7415&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cba7415",
  null
  
)

export default component.exports